import React from "react";
import { Container, Table } from "react-bootstrap";
import "./WebCommon.scss";
import { LeftArrow, LogoutIcon, RightArrow } from "../../../Assets/svgIcons";
import img1 from "../../../Assets/u_icon1.svg"
import img2 from "../../../Assets/u_icon2.svg"
import img3 from "../../../Assets/u_icon3.svg"
import { Link } from "react-router-dom";
import { getMonthName } from "../../../Utils/common.utils";
import { useAuth } from "../../../Contexts/auth.context";

const UserDetailpage = ({ portfolioData, userEmail, userProfile }) => {
  const { auth } = useAuth();
  const userdata = [
    {
      img: img1,
      title: "User ID",
      value: auth?.userId,
    },
    {
      img: img1,
      title: "Full Name",
      value: userProfile?.[0]?.user_firstname + " " + userProfile?.[0]?.user_lastname,
    },
    {
      img: img2,
      title: "Email Address",
      value: userEmail ? userEmail : "N/A",
    },
    {
      img: img3,
      title: "Account Number",
      value: userProfile?.[0]?.bank_account_number||"N/A",
    }
  ];
  return (
    <>
      <section className="page_design user_detail">
        <Container>
          {/* <div className="backbtn mb-3">
            <Link to="/account"><span><LeftArrow /></span> Back</Link>
          </div> */}
          <div className="page_design_in">
            <div className="page_design_head">
              <h2>User Detail page</h2>
              {/* <button className="btn-style"><span><LogoutIcon /></span> Export</button> */}
            </div>
            <div className="user_detail_head">
              {userdata.map((item, index) => {
                return (
                  <div className="user_detail_head_col text-center" key={index}>
                    <div className="user_detail_head_item">
                      <img src={item.img} alt="icon" />
                      <p className="grey_text">{item.title}</p>
                      <h3>{item.value}</h3>
                    </div>
                  </div>
                );
              })}
            </div>
            {portfolioData?.length ? <> <div className="user_detail_portfolio">
              <p className="grey_text">Portfolio value statement</p>
              <p>Please find the user portfolio values report for the selected date range. The report displays data for each month-end.</p>
            </div>
              <div className="page_design_body">
                <Table responsive>
                  <thead>
                    <tr>
                      <th></th>
                      <th>Sr No.</th>
                      <th>Year</th>
                      <th>Month</th>
                      <th>Portfolio Value</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {portfolioData.map((item, index) => {
                      return (
                        <tr key={index}>

                          <td></td>
                          <td>{index + 1}</td>
                          <td>{item.year}</td>
                          <td>{getMonthName(item.month)}</td>
                          <td>{item.portfolio_value}</td>
                          <td></td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
                {/* <div className="custom_pagination">
                <button className="prev_page">
                  <LeftArrow />
                </button>
                <ul>
                  <li>
                    <button>1</button>
                  </li>
                  <li>
                    <button className="active">2</button>
                  </li>
                  <li>
                    <button>3</button>
                  </li>
                  <li>
                    <button>...</button>
                  </li>
                  <li>
                    <button>12</button>
                  </li>
                </ul>
                <button className="next_page">
                  <RightArrow />
                </button>
              </div> */}
              </div></> : ''}
          </div>
        </Container>
      </section>
    </>
  );
};

export default UserDetailpage;
